module.exports = __webpack_public_path__ + "static/media/fam4.ca87e460.png";